var data = {
	"body": "<path d=\"M512 0Q373 0 255 68.5T68.5 255T0 512t68.5 257T255 955.5t257 68.5t257-68.5T955.5 769t68.5-257t-68.5-257T769 68.5T512 0zm0 961q-73 0-141.5-22.5T247 874t-96.5-97t-64-123.5T64 512q0-91 35.5-174T195 195t143-95.5T512 64t174 35.5T829 195t95.5 143T960 512t-35.5 174T829 829.5t-143 96T512 961zm32-462V192q0-13-9.5-22.5T512 160t-22.5 9.5T480 192v320q0 14 10 23l.5 1l.5 1l159 158q9 10 22.5 10t22.5-9.5t9-23t-9-22.5z\" fill=\"currentColor\"/>",
	"width": 1024,
	"height": 1024
};
exports.__esModule = true;
exports.default = data;
